import { styled } from '@mui/material';
import { visuallyHidden } from '@mui/utils';
import { forwardRef } from 'react';

import { UiButton } from '@ui/atoms-button';
import { ChkIconLoader } from '@ui/checkout-components';

import type { UiButtonWithLoadingProps } from './ButtonWithLoading.types';

export const UiButtonWithLoading = forwardRef<
  HTMLButtonElement | null,
  UiButtonWithLoadingProps
>(
  (
    {
      isLoading,
      loadingLabel,
      loaderProps,
      children,
      disabled,
      ...rest
    }: UiButtonWithLoadingProps,
    ref
  ) => {
    return (
      <StyledButton
        ref={ref}
        aria-busy={isLoading}
        disabled={isLoading || disabled}
        {...rest}
      >
        {isLoading && (
          <LoadingContent>
            <ChkIconLoader {...loaderProps} aria-hidden="true" />
            <span style={visuallyHidden}>{loadingLabel}</span>
          </LoadingContent>
        )}
        <ChildrenContent $isLoading={isLoading}>{children}</ChildrenContent>
      </StyledButton>
    );
  }
);

const StyledButton = styled(UiButton)({
  position: 'relative',
});

const LoadingContent = styled('span')({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

const ChildrenContent = styled('span')<{ $isLoading?: boolean }>(
  ({ $isLoading }) => ({
    visibility: $isLoading ? 'hidden' : 'visible',
  })
);
